import React, { useContext } from 'react'
import { ApiDataContext } from '../../Contexts/ApiData';
import Banner from '../../Components/Banner';
import UserCard from '../../Components/Cards/UserCard';

const CoreCommittes = () => {
    const apiData = useContext(ApiDataContext);

    const pageBanner = apiData?.PageBanner;
    const coreCommittes = apiData?.CoreLeaders?.sort((a, b) => (a.SortOrder - b.SortOrder));
    return (
        <>
            {pageBanner && pageBanner.length ? (
                <Banner
                    heading={pageBanner[0].PageBannerTitle}
                    imgUrl={pageBanner[0].DisplayURL}
                    alt={"About Us"}
                />
            ) : (
                <></>
            )}
            {coreCommittes && coreCommittes.length ? (
                <section className="board-management the-presidents">
                    <div className="container">
                        <div className="monin-service-title">
                            <h2 className="sub-title text-center mb-3">Core Committee</h2>
                        </div>
                        <div className="row justify-content-center">
                            {coreCommittes?.map((leader) => (
                                <UserCard
                                    key={leader?.LeaderId}
                                    name={leader?.LeaderName}
                                    summary={leader?.LeaderDesignation}
                                    duration={leader?.Duration}
                                    imgUrl={leader?.DisplayURL}
                                />
                            ))}
                        </div>
                    </div>
                </section>
            ) : (
                <></>
            )}
        </>
    )
}

export default CoreCommittes